export default __webpack_public_path__ + "static/media/Marlett.d71c74b6.ttf";